import { ContratoRemanejo } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { ContratoItem } from './contrato-item.model';

export class ContratoRemanejoItem extends BaseResourceModel {
  constructor(
    public valor_unitario?: number,
    public quantidade?: number,
    public contrato_item?: ContratoItem,
    public saldo?: number,
    public remanejo?: ContratoRemanejo,
  ) {
    super();
  }
  static converteJson(json: any): ContratoRemanejoItem {
    return Object.assign(new ContratoRemanejoItem(), json);
  }
}
